import { CredentialsPages } from './CredentialsPages';

export default CredentialsPages;
